import React from 'react';

export default function Logo() {
  return (
    <>
      <span className="kido-logo-mark">k</span>
      <span>KIDO <small>კიდო</small></span>
    </>
  );
}
